import { render, staticRenderFns } from "./VerifyInvitation.vue?vue&type=template&id=5d4ca9a2&scoped=true&"
import script from "./VerifyInvitation.vue?vue&type=script&lang=js&"
export * from "./VerifyInvitation.vue?vue&type=script&lang=js&"
import style0 from "./VerifyInvitation.vue?vue&type=style&index=0&id=5d4ca9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ca9a2",
  null
  
)

export default component.exports